import { Box } from '@mui/material';
import SelectBase from 'components/forms/fields/select-field/select-base/select-base.component';
import { useKitchenCapacityContext } from 'components/kitchen-capacity/kitchen-capacity.context';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CustomHeaderToolbar = () => {
  const { t } = useTranslation();

  const {
    preparationTime: { handleCalendarViewChange },
  } = useKitchenCapacityContext();

  const [calendarView, setCalendarView] = useState('week');

  const calendarViewTypes = [
    {
      label: t(
        'KitchenCapacity.preparationTime.calendar.customHeaderToolbar.calenderViews.list',
      ),
      id: 'list',
      test: 'PreparationTimeCalendar.Toolbar.CalenderViews.List.Button',
    },
    {
      label: t(
        'KitchenCapacity.preparationTime.calendar.customHeaderToolbar.calenderViews.week',
      ),
      id: 'week',
      test: 'PreparationTimeCalendar.Toolbar.CalenderViews.Week.Button',
    },
  ];

  const handleCalendarView = e => {
    setCalendarView(e.target.value);
    handleCalendarViewChange(e.target.value);
  };

  return (
    <Box data-testid="PreparationTimeCalendar.Toolbar">
      <SelectBase
        options={calendarViewTypes}
        onChange={handleCalendarView}
        value={calendarView}
        size="small"
        color="primary"
        fullWidth={false}
        data-testid="PreparationTimeCalendar.Toolbar.View.Select"
      />
    </Box>
  );
};

export default CustomHeaderToolbar;
